import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import TagForm from "../tags/TagForm";
import TagView from "../tags/TagView";
import TagsControl from "../tags/TagsControl";
import { FormattedMessage } from "react-intl";

const TagsMenu = () => {
    const [activeTag, setActiveTag] = useState<string|null>(null);
    const filter = useSelector((state: RootState) => state.notes.filter);
    const accountTags = useSelector((state: RootState) => state.app.accountTags);

    useEffect(() => {
        if(filter && 'tag' in filter) {
            setActiveTag(filter['tag'])
        } else {
            setActiveTag(null)
        }
    }, [filter])

    return <>
        <div className="sidebar-section-header">
            <h3><FormattedMessage id="tags"/></h3> <TagsControl/>
        </div>        
        <div className="tags-menu">
        {accountTags.map(accountTag => {
            return <Link key={'tags-menu-account-tag' + accountTag.tagId} to={'/notes?tagId=' + accountTag.tagId}>
                    <TagView accountTag={accountTag}/>
                </Link>
            })}
            <TagForm/>
        </div>
    </>
}
export default TagsMenu;